export default __webpack_public_path__ + "static/media/plus.d465bdda.png";